"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIdentity = void 0;
var _utils = require("../../utils");
var _UserAnalytics = require("./UserAnalytics");
var ls = _interopRequireWildcard(require("local-storage"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var initializeAnalytics = function initializeAnalytics(data) {
  var email = data.email,
    nickName = data.nickName,
    profile = data.profile;
  if (window.heap) {
    window.heap.identify(email.toLowerCase());
  }
  var landingPage = ls.get(_UserAnalytics.SIGNUP_PAGE_REFERRAL_LS_ITEM_NAME);
  var identifyHash = _objectSpread(_objectSpread({}, Object.assign({
    email: email,
    nickName: nickName
  }, profile)), {}, {
    landingPage: landingPage
  });
  if (profile) {
    var roleName = profile.roleName;
    (0, _UserAnalytics.setupHeapUser)(identifyHash, roleName);
  }
  (0, _UserAnalytics.identifyCio)(identifyHash);
  if (landingPage) {
    ls.remove(_UserAnalytics.SIGNUP_PAGE_REFERRAL_LS_ITEM_NAME);
  }
};
var LOGGED_OUT_SIGNIFIER = 'logged-out-signifier';
var useIdentity = function useIdentity() {
  var userInfoReq = (0, _utils.useRequest)(function (refreshSession) {
    return {
      url: (0, _utils.getUserInfoUrl)(refreshSession),
      withErrorsHandler: false
    };
  }, {
    onError: function onError(e) {
      return (0, _UserAnalytics.forgetUser)();
    },
    onSuccess: function onSuccess(data, _ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        refreshSession = _ref2[0];
      // If user is creating their initial session after a successful login
      if (!refreshSession) {
        initializeAnalytics(data);
      }
    }
  });
  var wipeIdentity = function wipeIdentity() {
    userInfoReq.mutate(null);
    (0, _UserAnalytics.forgetUser)();
  };

  // We need a special value to signify the user manually logged out,
  // so that guardRenderingApp knows to redirect to the special Auth0 logout page,
  // instead of directly to the /sign-in page.
  var logout = function logout() {
    userInfoReq.mutate(LOGGED_OUT_SIGNIFIER);
    (0, _UserAnalytics.forgetUser)();
  };
  return {
    // NOTE: It is important that loading initializes with true
    // so that rest of app doesn't mount until identity request is completed
    loadingUser: userInfoReq.loading,
    identity: userInfoReq.data === LOGGED_OUT_SIGNIFIER ? null : userInfoReq.data,
    wipeIdentity: wipeIdentity,
    isLoggedOut: userInfoReq.data === LOGGED_OUT_SIGNIFIER,
    logout: logout,
    refetchUser: function refetchUser() {
      userInfoReq.runAsync(true).catch(function (e) {
        return (0, _UserAnalytics.forgetUser)();
      });
    }
  };
};
exports.useIdentity = useIdentity;